<template lang="html">
  <div class="footer-wrapper">
    <div class="upper-wrapper">
      <div class="contact-wrapper">
        <div class="contact-header">
          <span>{{ $t("footer.contact.header") }}</span>
        </div>
        <div class="contact-info-wrapper">
          <div class="contact-info">
            <div class="info-img-wrapper">
              <img src="@/assets/icons/pin.png" alt="pin icon" />
            </div>
            <div class="info">
              {{ $t("footer.contact.pin") }}
            </div>
          </div>
          <div class="contact-info">
            <div class="info-img-wrapper">
              <a href="mailto:eberza@afeja.com">
                <img src="@/assets/icons/mail.png" alt="mail icon" />
              </a>
            </div>
            <div class="info">
              <a href="mailto:eberza@afeja.com">
                {{ $t("footer.contact.email") }}
              </a>
            </div>
          </div>
          <div class="contact-info">
            <div class="info-img-wrapper">
              <img src="@/assets/icons/phone.png" alt="phone icon" />
            </div>
            <div class="info">
              {{ $t("footer.contact.phone") }}
            </div>
          </div>
        </div>
      </div>
      <div class="newsletter-wrapper">
        <div class="header">
          <span>{{ $t("footer.newsletter.newsletter") }}</span>
        </div>
        <div class="description">
          {{ $t("footer.newsletter.description") }}
        </div>
        <div class="input-wrapper">
          <input
            @keyup.enter="setNewsletter"
            v-model="email"
            :placeholder="$t('footer.newsletter.placeholder')"
            type="text"
            class="regular-input"
          />
          <img
            @click="setNewsletter"
            src="@/assets/icons/newsletterArrow.png"
            alt="arrow image"
          />
        </div>
        <TurnStile :resetToken="resetToken" @set-token="setToken" />
      </div>
      <div class="navigation-wrapper">
        <img src="@/assets/images/logoWhite.png" alt="logo image" />
        <div class="links-wrapper">
          <div class="links">
            <router-link
              :to="{ name: 'About', params: { lang: $i18n.locale } }"
              >{{ $t("nav.about") }}</router-link
            >
            <router-link
              :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
              >{{ $t("nav.rules") }}</router-link
            >
            <!-- <router-link :to="{ name: 'Competitions', params: { lang: $i18n.locale } }">{{$t('nav.competitions')}}</router-link> -->
            <router-link
              :to="{ name: 'Faq', params: { lang: $i18n.locale } }"
              >{{ $t("nav.faq") }}</router-link
            >
          </div>
          <div class="links">
            <router-link
              :to="{ name: 'News', params: { lang: $i18n.locale } }"
              >{{ $t("nav.news") }}</router-link
            >
            <router-link
              v-if="userName"
              :to="{ name: 'Profile', params: { lang: $i18n.locale } }"
              >{{ $t("nav.profile") }}
            </router-link>
            <!-- <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.sugestions')}}</router-link> -->
            <router-link
              v-if="userAdmin"
              :to="{ name: 'Admin', params: { lang: $i18n.locale } }"
              >Admin</router-link
            >
          </div>
        </div>
      </div>
    </div>
    <span v-html="$t('footer.intellectualProperty')" class="rights"> </span>
    <div class="lower-wrapper">
      <!-- <div class="terms-wrapper">
        <span>{{$t('footer.terms')}}</span>
        <span>{{$t('footer.privacy')}}</span>
      </div> -->
      <div class="rights">
        {{ $t("footer.rights") }}
      </div>
      <div class="socials">
        <a href="https://www.instagram.com/eberza.rs/" target="_blank">
          <img src="@/assets/icons/instagram.png" alt="instagram logo" />
        </a>
        <a href="https://www.facebook.com/eberza.rs" target="_blank">
          <img src="@/assets/icons/facebook.png" alt="facebook logo" />
        </a>
        <!-- href="https://www.linkedin.com/in/eberza-afeja-ltd-a72496231/" -->
        <a
          href="https://www.linkedin.com/company/eberza-afeja-ltd/"
          target="_blank"
        >
          <img src="@/assets/icons/linkedIn.png" alt="linkedIn logo" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import { mapState } from "vuex";
import TurnStile from "../components/TurnStileVue2.vue";

export default {
  name: "Footer",
  components: {
    TurnStile
  },
  data() {
    return {
      email: "",
      localToken: "",
      resetToken: false
    };
  },
  methods: {
    async setNewsletter() {
      // await this.$recaptchaLoaded();
      // let token = await this.$recaptcha("newsletter");

      const params = {
        token: this.localToken,
        email: this.email
      };
      this.resetToken = !this.resetToken;

      api
        .setNewsletter(params)
        .then(res => {
          this.email = "";
          this.$toast.success(this.$t("main.newsletterSuccess"), {
            duration: 8000
          });
        })
        .catch(e => {
          console.log(e);
          this.$toast.error(this.$t("main.newsletterError"), {
            duration: 8000
          });
        });
    },
    setToken(e) {
      this.localToken = e;
    }
  },
  computed: {
    ...mapState(["userAdmin", "userName"])
  }
};
</script>

<style lang="scss" scoped>
.footer-wrapper {
  margin-top: auto;
  // background-image: url('../assets/images/footerBackground.png');
  // background-size: cover;
  background: #404040;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 60px 100px 0px 100px;
  text-align: left;

  .upper-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 60px;

    .contact-wrapper {
      width: 360px;

      .contact-header {
        margin-bottom: 40px;
        text-align: left;
        font-weight: bold;
        font-size: 16px;
        line-height: 26px;
        font-family: "Open Sans";
        span {
          border-bottom: 1px solid $main-color;
          padding-bottom: 5px;
        }
      }
      .contact-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 15px;

        .info {
          font-size: 14px;
          line-height: 23px;
          opacity: 0.8;

          a {
            text-decoration: none;
            color: white;
          }
        }
        .info-img-wrapper {
          margin-right: 15px;
          width: 16px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
      }
      .contact-info:last-child {
        margin-bottom: 0px;
      }
    }

    .newsletter-wrapper {
      .header {
        margin-bottom: 40px;
        font-weight: bold;
        font-size: 16px;
        line-height: 26px;
        text-align: center;
        font-family: "Open Sans";
        span {
          border-bottom: 1px solid $main-color;
          padding-bottom: 5px;
        }
      }
      .description {
        // font-weight: 500;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        letter-spacing: 0.03em;
        width: 350px;
        margin-bottom: 10px;
        // opacity: 0.8;
      }
      .input-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid white;
        height: 30px;

        input {
          flex-grow: 1;
          color: white;
          background: transparent;
          border: none;
          outline: none;
          font-weight: 600;
          font-size: 13px;
          letter-spacing: 0.03em;
          line-height: 21px;
          min-width: 100px;
        }
        input::placeholder {
          color: white;
          font-weight: 400;
          font-size: 13px;
          letter-spacing: 0.03em;
          line-height: 21px;
          font-style: italic;
        }
        img {
          cursor: pointer;
        }
      }
    }

    .navigation-wrapper {
      width: 250px;
      padding-left: 5%;
      display: flex;
      flex-direction: column;

      img {
        height: 35px;
        width: auto;
        margin-right: auto;
        margin-bottom: 35px;
        margin-top: -15px;
        border-bottom: 1px solid $main-color;
        padding-bottom: 8px;
      }
      .links-wrapper {
        display: flex;
        flex-direction: row;

        .links {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          a {
            margin-bottom: 12px;
            text-decoration: none;
            color: white;
            text-transform: uppercase;
            font-weight: bold;
            font-size: 12px;
            line-height: 20px;
            letter-spacing: 0.06em;
            font-family: "Open Sans";
          }
        }
        .links:first-child {
          margin-right: 80px;
        }
      }
    }
  }
  .rights {
    font-size: 12px;
    line-height: 20px;
    opacity: 0.8;
    margin-bottom: 10px;

    span {
      opacity: 1;
      color: white;
      font-weight: 700;
    }
  }
  .lower-wrapper {
    margin-top: auto;
    height: 90px;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    opacity: 0.8;

    .terms-wrapper {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      min-width: 170px;
      cursor: pointer;
      white-space: nowrap;
      span {
        padding: 0 20px 0 0;
      }
      span:last-of-type {
        padding: 0 0 0 0 !important;
      }
    }
    .socials {
      width: 170px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      img {
        margin-left: 40px;
        cursor: pointer;
      }
    }
  }
}
@media only screen and (max-width: 1100px) {
  .footer-wrapper {
    padding: 60px 40px 0px 40px;

    .upper-wrapper {
      flex-direction: column;

      .contact-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 60px auto;
      }
      .newsletter-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 80px auto;

        .description {
          width: auto;
          margin: 0 auto 20px auto;
        }
      }
      .navigation-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 0px auto;
        padding-left: 0px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .footer-wrapper {
    .upper-wrapper {
      .links-wrapper {
        justify-content: space-between;
        flex-wrap: wrap;
        .links:first-child {
          margin-right: 0px !important;
        }
      }
    }
    .lower-wrapper {
      height: auto;
      flex-direction: column;

      div {
        margin: 20px auto 0px auto;
      }
      div:last-child {
        margin-bottom: 20px;
      }
      .socials {
        justify-content: space-between;

        img:first-child {
          margin-left: 0px;
        }
      }
    }
  }
}
</style>
